import React, { useState } from "react";
import classnames from "classnames";

import styles from "./OrganizationType.module.css";

import { ORGANIZATIONTYPE } from '../../constant'

interface Props {
  organizationTypes: any;
  updateOrganizationTypes: (organizationTypes: any) => void;
}

function OrganizationType(props: Props) {
  const { organizationTypes, updateOrganizationTypes } = props;
  const [types, setTypes] = useState<any>([]);
  return (
    <div className={styles.container}>
      <div className={styles.label}>机构类型</div>
      <div className={styles.value}>
        <button
          className={classnames(styles.default, {
            [styles.active]: (!organizationTypes || organizationTypes.length===0)
          })}
          onClick={() => {
            setTypes([]);
            updateOrganizationTypes([]);
          }}
        >
          不限
        </button>
        {ORGANIZATIONTYPE.map((val, index) => {
          return (
            <div
              key={index}
              className={styles.wrapper}
              onClick={() => {
                let typesArr = types
                if(typesArr && Array.isArray(typesArr)){
                  const index = typesArr.indexOf(val.id)
                  if(index>-1){
                    let arr = []
                    for(let i=0;i<typesArr.length;i++){
                      if(i!=index){
                        arr.push(typesArr[i])
                      }
                    }
                    typesArr = arr
                  }else{
                    typesArr = typesArr.concat([val.id])
                  }
                  setTypes(typesArr);
                   updateOrganizationTypes(typesArr);
                }else{
                  setTypes([]);
                  updateOrganizationTypes([]);
                }
              }}
            >
              <div className={[styles.select, types.indexOf(val.id)>-1?styles.selected:''].join(" ")}></div>
              <div className={styles.selecttxt}>{val.name}</div>
            </div>
          )
        })}
      </div>
    </div>
  );
}

export default OrganizationType;
